import httpClient from "../../clients/httpClient";
import { IQuery } from "../../interfaces/meta.interface";
import {
    IAchievementPreviewPayload,
    IAchievementSummary,
    IOrganizationAchievement,
    IOrganizationAchievementDependenciesPayload,
    IOrganizationAchievementEarnedExportPayload,
    IOrganizationAchievementsPayload,
    IUserAchievementResponse,
} from "../../interfaces/organization-achievement.interface";

export const getOrganizationAchievements = (
    payload: IOrganizationAchievementsPayload = {}
) => {
    const { page, perPage, search, type, status, sort_by, sort_dir,trigger_identifier } = payload;
    const params: Record<string, string | number> = {};
    if (page !== undefined) params.page = page;
    if (perPage !== undefined) params.per_page = perPage;
    if (search) params.search = search;
    if (type) params.type = type;
    if (status) params.status = status;
    if (sort_by) params.sort_by = sort_by;
    if (sort_dir) params.sort_dir = sort_dir;
    if (trigger_identifier) params.trigger_identifier = trigger_identifier;
    return httpClient.get(`/api/v1/organization-achievements`, { params });
};

export const getOrganizationAchievement = (id: string) => {
    return httpClient.get(`/api/v1/organization-achievements/${id}`);
};

export const getOrganizationAchievementTemplates = () =>
    httpClient.get(`/api/v1/organization-achievements/templates`);

export const createOrganizationAchievement = (payload: FormData) => {
    return httpClient.post<IOrganizationAchievement>(
        "/api/v1/organization-achievements",
        payload
    );
};

export const editOrganizationAchievement = (id: number, payload: FormData) => {
    return httpClient.post<IOrganizationAchievement>(
        `/api/v1/organization-achievements/${id}`,
        payload
    );
};

export const previewOrganizationAchievement = (payload: IAchievementPreviewPayload) =>
    httpClient.post<IAchievementSummary>(
        "/api/v1/organization-achievements/preview",
        payload
    );

export const deleteOrganizationAchievement = (id: number) => {
    return httpClient.delete(`/api/v1/organization-achievements/${id}`);
};

export const getAchievementsEarnedRequest = (
    payload: IOrganizationAchievementEarnedExportPayload
) => {
    return httpClient.get(`/api/v1/reports/achievements-earned`, {
        params: {
            page: payload.page,
            per_page: payload.perPage,
            starts_at: payload.startsAt,
            ends_at: payload.endsAt,
            search: payload.search,
            order_by: payload.orderBy,
            direction: payload.sortDirection,
        },
    });
};

export const exportAchievementsEarnedRequest = (
    payload: IOrganizationAchievementEarnedExportPayload
) => {
    return httpClient.get(`/api/v1/reports/achievements-earned/export`, {
        params: {
            starts_at: payload.startsAt,
            ends_at: payload.endsAt,
            timezone: payload.timezone,
        },
    });
};

export const getAllAchievementsRequest = (
    type?: "achievement" | "mission"
) => {
    return getOrganizationAchievements(type ? { type } : {});
};

export const sortAchievementsRequest = (
    ids: number[]
) => {
    return httpClient.patch(
        `/api/v1/organization-achievements/sort`,
        { ids }
    );
};

export const addOrganizationAchievementDependencies = (
    id: number, 
    payload: IOrganizationAchievementDependenciesPayload
) => {
    return httpClient.post(
        `/api/v1/organization-achievements/${id}/dependencies`,
        payload
    );
};


export const getUserEarnedAchievements = (organizationId: number, userId: number, query: IQuery) => {
    return httpClient.get<IUserAchievementResponse>(`/api/v1/organizations/${organizationId}/customer/${userId}/organization-achievements`, {
        params: {
            page: query.page,
            per_page: query.perPage,
        },
    });
};

export const getUserAchievementProgressLogs = (organizationId: number, userId: number, query: IQuery) => {
    return httpClient.get<IUserAchievementResponse>(`/api/v1/organizations/${organizationId}/customer/${userId}/organization-achievements/progress`, {
        params: {
            page: query.page,
            per_page: query.perPage,
        },
    });
};

export const getMissionUserCount = (dependencies: number[], organizationAchievementId?: number) => {
    return httpClient.get<{ count: number }>(`/api/v1/organization-achievements/tiered/user-count`, {
        params: {
            dependencies,
            organization_achievement_id: organizationAchievementId,
        },
    });
};
